import {Injectable} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material/icon';
import {SaAssets, ICONS, IMG, ImgEnum} from '../models/assets.model';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssetsService {
  private static images: any = {};
  private readonly assetsUrl = `${environment.assetUrl}/smart-assistant/assets`;
  
  constructor(
      private readonly matIconRegistry: MatIconRegistry,
      private readonly domSanitizer: DomSanitizer
  ) {
    this.registerIcons();
    this.preloadImages();
  }
  
  public getAssetSource(imageName: ImgEnum) {
    return AssetsService.images[imageName].src;
  }
  
  public registerIcons() {
    Object.values(ICONS).forEach((icon: SaAssets) => {
      this.matIconRegistry.addSvgIcon(
          icon.name,
          this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.assetsUrl}/icons/${icon.filename}`)
      );
    });
  }
  
  private preloadImages() {
    Object.values(IMG).forEach((image: SaAssets) => {
      AssetsService.images[image.name] = new Image();
      AssetsService.images[image.name].src = `${this.assetsUrl}/images/${image.filename}`;
      AssetsService.images[image.name].loading = 'lazy';
      AssetsService.images[image.name].decoding = 'async';
    });
  }
}
